module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Electric/Washer-b4d53c0263cc6d01f3259743b9386dfd.svg";